<main>
  <div class="container-fluid">
    <div class="row">
      <div class="col-12">
        <section class="mt-3">
          <app-registration-approval-prompt></app-registration-approval-prompt>
        </section>
        <section>
          <div class="video-link-container p-3 my-5">
            <h4 class="me-auto mb-0">دسترسی به ویدیوهای کارگاههای آموزشی</h4>
            <a href="/e-workshop/e-workshops">
              <button class="btn btn-success mt-sm-0 mt-2">
                مشاهده ویدیو ها
              </button>
            </a>
          </div>
        </section>
        <section>
          <app-my-upcoming-workshop-list></app-my-upcoming-workshop-list>
        </section>
        <section>
          <app-afra-magazine></app-afra-magazine>
        </section>
        <div class="bg-transparent m-5 p-5"></div>
      </div>
      <div class="py-5"></div>
    </div>
  </div>
</main>
